import React from 'react';
import './Products.css';
import './AllSellStyles.css';
import './CommonStyles.css';

const PurchaseSaleReport = () => {

    return (
        <div style={{ paddingTop: '0.5rem' }}>

            {/* ── Two-column Metrics Grid ── */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>

                {/* Purchases Card */}
                <div style={{
                    background: '#fff', border: '1px solid #e2e8f0', borderRadius: '10px',
                    padding: '1.25rem 1.5rem', boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                }}>
                    <div style={{ fontWeight: '600', fontSize: '0.95rem', color: '#475569', marginBottom: '1rem', paddingBottom: '0.5rem', borderBottom: '1px solid #e2e8f0' }}>
                        Purchases
                    </div>
                    {[
                        { label: 'Total Purchase:',                         value: '$ 2,048.63', hi: true },
                        { label: 'Purchase Including tax:',                  value: '$ 2,048.63' },
                        { label: 'Total Purchase Return Including Tax:',     value: '$ 436.99',  hi: true },
                        { label: 'Purchase Due: ⓘ',                         value: '$ 0.00' },
                    ].map((row, i) => (
                        <div key={i} style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            padding: '0.5rem 0.5rem',
                            background: row.hi ? '#f8fafc' : 'transparent',
                            borderBottom: '1px solid #f1f5f9',
                        }}>
                            <span style={{ fontSize: '0.8125rem', color: '#334155', fontWeight: '500' }}>{row.label}</span>
                            <span style={{ fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600' }}>{row.value}</span>
                        </div>
                    ))}
                </div>

                {/* Sales Card */}
                <div style={{
                    background: '#fff', border: '1px solid #e2e8f0', borderRadius: '10px',
                    padding: '1.25rem 1.5rem', boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                }}>
                    <div style={{ fontWeight: '600', fontSize: '0.95rem', color: '#475569', marginBottom: '1rem', paddingBottom: '0.5rem', borderBottom: '1px solid #e2e8f0' }}>
                        Sales
                    </div>
                    {[
                        { label: 'Total Sale:',                             value: '$ 1,000.32', hi: true },
                        { label: 'Sale Including tax:',                     value: '$ 10,011.80' },
                        { label: 'Total Sell Return Including Tax:',        value: '$ 0.00',    hi: true },
                        { label: 'Sale Due: ⓘ',                            value: '$ 520.85' },
                    ].map((row, i) => (
                        <div key={i} style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            padding: '0.5rem 0.5rem',
                            background: row.hi ? '#f8fafc' : 'transparent',
                            borderBottom: '1px solid #f1f5f9',
                        }}>
                            <span style={{ fontSize: '0.8125rem', color: '#334155', fontWeight: '500' }}>{row.label}</span>
                            <span style={{ fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600' }}>{row.value}</span>
                        </div>
                    ))}
                </div>
            </div>

            {/* ── Overall Summary Card ── */}
            <div style={{
                background: '#fff', border: '1px solid #e2e8f0', borderRadius: '10px',
                padding: '1.25rem 1.5rem', boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem', color: '#64748b' }}>
                    <span style={{ fontSize: '0.95rem' }}>Overall ((Sale − Sell Return) − (Purchase − Purchase Return))</span>
                    <i className="fa fa-info-circle" style={{ color: '#0ea5e9' }} />
                </div>
                <div style={{ marginBottom: '0.75rem' }}>
                    <span style={{ fontSize: '1rem', color: '#64748b' }}>
                        Sale − Purchase: <strong style={{ color: '#22c55e' }}>$ 8,400.16</strong>
                    </span>
                </div>
                <div>
                    <span style={{ fontSize: '1rem', color: '#64748b' }}>
                        Due amount: <strong style={{ color: '#22c55e' }}>$ 520.85</strong>
                    </span>
                </div>
            </div>

        </div>
    );
};

export default PurchaseSaleReport;
